 <div class="customer_wrap" [ngClass]="{'open_class': isSideMenuOpen}">
    <div class="navprt">
        <div class="leftlogo">
            <button (click)="toggleSideMenu()">
                <mat-icon> menu</mat-icon>
             </button>
             <div [routerLink]="['/']" class="sidenav-toolbar-logo">
                 <img src="../../../assets/img/elite-logo.svg" alt="logo"/>
             </div>
        </div>
    
     </div>
     <fury-page-layout mode="card">
        <fury-page-layout-header>
            <div class="header_vew">
                <fury-breadcrumbs [@fadeInRight]  current="Customer Dashboard"></fury-breadcrumbs>
                <div class="top_heading">
                    
                    <div class="btn_panel">
                        
                        <button mat-raised-button class="green" (click)="reload()">
                            <span class="iconprt">
                                <mat-icon>refresh</mat-icon>
                            </span>
                            <span>
                                Refresh
                            </span>
                        </button>
                        <button mat-raised-button class="deepred"  *ngIf="editorAccess"  (click)="handleAddComplaint()">
                            <span class="iconprt">
                                <mat-icon>add</mat-icon>
                            </span>
                            <span>
                                Add Complaint
                            </span>
                        </button>

                        <button mat-raised-button color="primary" *ngIf="editorAccess"  (click)="handleAddAgreement()">
                            <span class="iconprt">
                                <mat-icon>add</mat-icon>
                            </span>
                            <span>
                                Add New Agreement
                            </span>
                        </button>
                        <button mat-raised-button color="accent"  *ngIf="editorAccess"  (click)="handleAddClaim()">
                            <span class="iconprt">
                                <mat-icon>add</mat-icon>
                            </span>
                            <span>
                                Add New Claim
                            </span>
                        </button>
                        <button mat-raised-button class="deepblue" *ngIf="editorAccess" (click)="handleEditCustomer()">
                            <span class="iconprt">
                                <mat-icon>edit</mat-icon>
                            </span>
                            <span>
                                Edit Customer
                            </span>
                        </button>
                        <!-- <button mat-raised-button class="deepyellow">
                            <span class="iconprt">
                                <mat-icon>update</mat-icon>
                            </span>
                            <span>
                                Update Payment
                            </span>
                        </button> -->
                        <button mat-raised-button class="deepredviolet"  *ngIf="editorAccess"  (click)="handleChargeManually()">
                            <span class="iconprt">
                                <mat-icon>battery_charging_full</mat-icon>
                            </span>
                            <span>
                                Charge Manually
                            </span>
                        </button>
                        <button mat-raised-button class="orenge" *ngIf="editorAccess" (click)="handleAddNotes()">
                            <span class="iconprt">
                                <mat-icon>add</mat-icon>
                            </span>
                            <span>
                                Add Mass Note
                            </span>
                        </button>
                        <button mat-raised-button class="deepviolet" *ngIf="editorAccess" (click)="handleSpecialRequest()">
                            <span class="iconprt">
                                <mat-icon>folder_special</mat-icon>
                            </span>
                            <span>
                                Special Request
                            </span>
                            
                        </button>
                        <!-- <button mat-raised-button class="deepredviolet">
                            <span class="iconprt">
                                <mat-icon> rate_review</mat-icon>
                            </span>
                            <span>
                                Review Request
                            </span>
                        </button> -->
                        <button mat-raised-button class="deepgreen" *ngIf="editorAccess" (click)="handleEditFeedback()">
                            <span class="iconprt">
                                <mat-icon>feedback</mat-icon>
                            </span>
                            <span>
                                Feedback Request
                            </span>
                        </button>
                    </div>

                    <!-- <button mat-button class="can-button black" (click)="this.location.back()">
                        <span class="iconprt">
                            <mat-icon>keyboard_backspace</mat-icon>
                        </span>
                        <span>
                            Back
                        </span>
                    </button> -->
                    <div>
                        <button mat-button class="can-button"
                        (click)="redirectToCustomerList()"><mat-icon>keyboard_backspace</mat-icon> Back</button>
                    </div>
                   
                </div>
            </div>
            
            
        </fury-page-layout-header>

        <div class="lebel_section">
            <fury-common-label-section [mainPage]="'customerDashboard'" ></fury-common-label-section>
        </div>

        <fury-page-layout-content [@fadeInUp]>
    
            <div class="two_section">
                <div class="customer_leftinfo">
                    <fury-customer-side-menu ></fury-customer-side-menu>
                </div>
                
                <div class="righpanel">
                    <fury-common-kpi-blocks [mainPage]="'customerDashboard'" [data]="kpiData"></fury-common-kpi-blocks>
                    <div class="panel">
                        <fury-payments-tabs [userId]="userId" [editorAccess]="editorAccess" [isFetchChargeManuallyApi]="isFetchChargeManuallyApi"></fury-payments-tabs>
                    </div>
                    <div class="panel">
                        <fury-billing-tabs [userId]="userId" [editorAccess]="editorAccess"></fury-billing-tabs>
                    </div>
                    <div class="panel">
                        <fury-agreements-tabs [userId]="userId" [editorAccess]="editorAccess"></fury-agreements-tabs>
                    </div>
                    <div class="panel">
                        <fury-claim-tab [userId]="userId" [editorAccess]="editorAccess" [services]="services"></fury-claim-tab>
                    </div>
                    <div class="panel">
                        <fury-leads-tabs [userId]="userId" [editorAccess]="editorAccess"></fury-leads-tabs>
                    </div>
                    <div class="panel">
                        <fury-feedback-tabs [userId]="userId" [editorAccess]="editorAccess"></fury-feedback-tabs>
                    </div>
                    <div class="panel">
                        <fury-notes-tabs [userId]="userId" [editorAccess]="editorAccess"></fury-notes-tabs>
                    </div>
                    <div class="panel">
                        <fury-special-request-tabs [userId]="userId" [editorAccess]="editorAccess" > </fury-special-request-tabs>
                    </div>
                    <div class="panel">
                        <fury-retention  [userId]="userId" [editorAccess]="editorAccess"></fury-retention>
                    </div>
                    
                </div>
            </div>
           
        </fury-page-layout-content>
       
    </fury-page-layout>
</div>  






